export const StockOrderStatusTypesEnum = {
    AllOrders: "1",
    OpenOrders: "2",
    OpenReturns: "3",
    SentOrders: "4",
    DispatchedOrders: "5",
    ReceivedOrders: "6",
    OverDueOrders: "7",
    CancelledOrders: "8",
    FailedOrders: "9",
    SentReturns: "10",
  };